module.exports = __webpack_public_path__ + "static/media/garmin-gpsmap-64s-2.903e02a1.jpg";